export default "__VITE_ASSET__Db6pMeR9__"